import { ControlValueAccessor } from '@angular/forms';

export abstract class ValueAccessor<T> implements ControlValueAccessor {
    private innerValue: T;

    private changed: (value: T) => void;
    private touched: () => void;

    protected disabled: boolean;

    public get value(): T {
        return this.innerValue;
    }
    public set value(value: T) {
        if (this.innerValue !== value) {
            // this.innerValue = value;
            this.writeValue(value);

            if (this.changed)
                this.changed(value);
        }
    }

    protected touch(): void {
        if (this.touched)
            this.touched();
    }

    // ControlValueAccessor
    public writeValue(value: T): void {
        this.innerValue = value;
        this.ngModelValueUpdated(value);
    }

    // ControlValueAccessor
    public registerOnChange(fn: (value: T) => void) {
        this.changed = fn;
    }

    // ControlValueAccessor
    public registerOnTouched(fn: () => void) {
        this.touched = fn;
    }

    // ControlValueAccessor
    public setDisabledState?(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    protected ngModelValueUpdated(newValue: T) {}
}



// WEBPACK FOOTER //
// ./src/viega-common/components/ValueAccessor.ts